import $ from 'jquery';
import clone from 'lodash/clone';

import eventManager from "../../store/sqftEventManager";
import config from "../../store/sqftConfig";
import workspace from "../workspace";
import {inchesToMm} from "../../../../helpers/sqftHelper";
import SqftStore from "../../store/sqftStore";
import {iconplusPurple} from "../../../../assetsSQFT";
import sqftShapeManager from "../../store/sqftShapeManager";
import {getWizardPropertiesForFeatureId} from "./resourseCanas";
//import TranslatesProvider from "./../../translatesProvider";

export default new function() {
  //private variables
  var self = this,
    //cursorImage = null,
    elements = {
      navRadius: $('#nav_radius'),
      overlay: $('#radius-overlay'),
      arcButtons: $('.lightbox-option-rectangular[data-arc]'),
      angleButtons: $('.lightbox-option-rectangular[data-angle]'),
      designDefault: $('#design-default'),
      closeButton: $('#radius-overlay .lightbox-cancel-button'),
      cornerContainer: $('#corner'),
      radiusContainer: $('#radius'),
      measure: $('[data-measure]')
    },
    maxRadius = 18,
    corners = 60;

  this.clickedBackSplashButton = null;
  this.cursorImage = null;
  this.isWaitingToRestoreCursor = false;

  //public variables
  this.arcLength = 0;
  this.angle = 0;
  //private events

  this.angleButton_onClick = function() {
    self.deregisterEvents();
    SqftStore.radius.arcLength = 0;
    SqftStore.radius.angle = $(this).attr('data-angle');
    self.handleButtonClick($(this));
    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
    $(this).addClass('lightbox-option-selected');
  };
  this.arcButton_onClick = function() {
    this.deregisterEvents();
    SqftStore.radius.angle = 0;
    SqftStore.radius.arcLength = $(this).attr('data-arc');
    self.handleButtonClick($(this));
    $('.lightbox-option-selected').removeClass('lightbox-option-selected');
    $(this).addClass('lightbox-option-selected');
  };

  this.handleButtonClick = function(item) {

    self.setHighlighting();
    self.clickedEdgeButton = item;
    self.setCursorImage();

    if (window.innerWidth < 991 && !config.tutorialIsRunning) {
      //Menu.hideSideBarContent(); // hide sidebar menu
    }

    // elements.overlay.hide();
  };

  this.deregisterEvents = function() {
    eventManager.resetCursor(self);
    eventManager.removeEvent(self);
    elements.navRadius.removeClass('steps-scope-config-button-selected');
    // QCDES-1139 fix
    //SqftStore.radius.arcLength = 0;
    //SqftStore.radius.angle = 0;
    config.highlight.points = false;
  };

  function createRadiusElements() {
    let html = '';
    for (let i = 1; i <= maxRadius; i++) {
      html +=
        ('<div class="lightbox-option-rectangular" data-arc="'+ i +'">\n' +
          '  <div class="lightbox-edge-graph lightbox-edge-graph-R'+ i * 10 +'"></div>\n' +
          '  <!--<div class="lightbox-help-icon lightbox-help-icon-rectangular"></div>-->\n' +
          '  <div class="lightbox-description-text-rectangular">' +
          '     <span data-value="radius">'+ i +'" </span>' +
          '     <span data-text="sqft.navigation.radius.radiusItem">'+ TranslatesProvider.translate("sqft.navigation.radius.radiusItem") + '</span>' +
          '  </div>\n' +
          '</div>');
    }
    elements.radiusContainer.html(html);
    elements.arcButtons = $('.lightbox-option-rectangular[data-arc]');
  }

  function createCornerElements() {
    let html = '';
    for (let i = 3; i <= corners; i += 3) {
      html += ('<div class="lightbox-option-rectangular" data-angle="'+ i +'">\n' +
        '        <div class="lightbox-angle-graph lightbox-angle-graph--r'+ i +'">\n' +
        '           <span class="lightbox-angle-graph--horizontal"></span>\n' +
        '           <span class="lightbox-angle-graph--vertical"></span>\n' +
        '         </div>\n' +
        '        <div class="lightbox-description-text-rectangular" data-value="corner">'+ i +'"</div>\n' +
        '      </div>');
    }
    elements.cornerContainer.html(html);
    elements.angleButtons = $('.lightbox-option-rectangular[data-angle]');
  }
  this.onMeasureUnitChange = () => {
    //nodes.buttons.radius
    elements.arcButtons.each(function () {
      switch(config.measureUnit) {
        case "Metric":
          $(this).find('[data-value="radius"]').html(inchesToMm(+this.dataset.arc) + config.getMeasureUnitPostfix());
          break;
        case "Imperial":
        default:
          $(this).find('[data-value="radius"]').html(+this.dataset.arc + config.getMeasureUnitPostfix());
      }
    });

    // nodes.buttons.corner
    elements.angleButtons.each(function () {
      switch(config.measureUnit) {
        case "Metric":
          $(this).find('[data-value="corner"]').html(inchesToMm(+this.dataset.angle) + config.getMeasureUnitPostfix());
          break;
        case "Imperial":
        default:
          $(this).find('[data-value="corner"]').html(+this.dataset.angle + config.getMeasureUnitPostfix());
      }
    });

    elements.measure.each(function () {
      switch(config.measureUnit) {
        case "Metric":
          $(this).html($(this).data('metric'));
          break;
        case "Imperial":
        default:
          $(this).html($(this).data('imperial'));
      }
    });
  };

  this.setCursorImage = function () {
    var item = self.clickedEdgeButton, // remember it to restore after moving canvas cursor switch
      bounds = 18,
      imgWidth = bounds,
      imgHeight = bounds;

    var domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    var $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });
    $img.attr({
      'data-id': item//.attr('data-id')
    });
    $img.on('load', function() {
      setImage(domImg);
    });
    $img.appendTo($('body'));
    $img.attr('src', iconplusPurple);

    function setImage(domImg) {
      var bounds = 18;
      let ratio;
      if(imgWidth > imgHeight) {
        ratio = imgHeight / imgWidth;
        imgWidth = bounds;
        imgHeight = bounds * ratio;
      } else {
        ratio = imgWidth / imgHeight;
        imgHeight = bounds;
        imgWidth = bounds * ratio;
      }
      eventManager.setCursor('edge-select', self, true);
      self.cursorImage = { image: domImg, width: imgWidth, height: imgHeight };
      self.registerEvents();
    }
  };

  this.setHighlighting = function () {
    eventManager.stealCursor(true); // remove all other cursors
    workspace.setAllowEdges(false); //  removing sizing lines
    workspace.setAllowBumpoutEdges(false); //  removing bumpout lines
    workspace.setAllowMiteredEdges(false); //  removing mitered lines
    config.highlight.lines = false;  // disable lines highlighting
    config.highlight.type = '';  // disable lines highlighting
    config.highlight.id = null;  // disable lines highlighting
  };

  this.registerEvents = function() {
    eventManager.setCursor('radius-select', self, true);
    config.highlight.points = true;
    eventManager.addEvent(
      eventManager.events.RENDER,
      self.renderCursor,
      self,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_DOWN,
      self.onMouseDown,
      self,
      eventManager.priorities.OVERALL
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      self.onMouseUp,
      self,
      eventManager.priorities.OVERALL
    );
  };
  this.onMouseDown = function() {
    let hoverPoint = workspace.getHoverPoint();
    //let hoverShape = workspace.getHoverShape();
    let hoverMiteredPoint = workspace.getHoverMiteredPoint();

    //update hoverPoint from miteredHoverPoint
    if(hoverMiteredPoint) {
      let miteredOverlay = hoverMiteredPoint.getParent();
      if(
        miteredOverlay && miteredOverlay.line && miteredOverlay.line.to
        && (miteredOverlay.line.to.isOverPointField()
        || miteredOverlay.line.from.isOverPointField())
      ){
        hoverPoint = miteredOverlay.line.to.isOverPointField() || miteredOverlay.line.from.isOverPointField()
      }
    }

    if (hoverPoint) {
      return true;  // return true; // block all mouse-down events // we need dragging workspace
    }
  };
  this.checkForRestoreCursor = function() {
    if (self.isWaitingToRestoreCursor) {
      self.isWaitingToRestoreCursor = false;
      eventManager.removeEvent(self, eventManager.events.MOUSE_UP); //remove mouse up, it will be added in setCursorImage
      self.setHighlighting();
      self.setCursorImage();
    }
  };

  this.addRadiiToPoint = (point) => {
    if (!point) {
      return false;
    }

    // Get wizard properties if featureId exists
    let fromWizardId, fromWizardStep, fromWizardGroupId;
    if (SqftStore.radius.featureId) {
      const wizardProps = getWizardPropertiesForFeatureId(SqftStore.radius.featureId);
      fromWizardId = wizardProps.fromWizardId;
      fromWizardStep = wizardProps.fromWizardStep;
      fromWizardGroupId = wizardProps.fromWizardGroupId;
    }

    if (SqftStore.radius.arcLength || SqftStore.radius.angle) {
      point.arcLength = SqftStore.radius.arcLength || 0;
      point.angle = SqftStore.radius.angle || 0;
      point.featureId = clone(SqftStore.radius.featureId);
      point.fromWizardId = fromWizardId;
      point.fromWizardStep = fromWizardStep;
      point.fromWizardGroupId = fromWizardGroupId;
      return true;
    }

    return false;
  };

  this.onMouseUp = (mousePos) => {
    void mousePos;
    this.checkForRestoreCursor();

    let hoverPoint = workspace.getHoverPoint(),
      hoverShape = workspace.getHoverShape(),
      hoverSegmentCorner;

    // Click on purple line
    if (hoverShape) {
      hoverSegmentCorner = hoverShape.getHoverSegmentCorner();
      if (hoverSegmentCorner) {
        hoverPoint = hoverSegmentCorner.line.to;
      }
    }

    if (hoverPoint && !hoverPoint.angleIsChanged && hoverPoint.isFitSize()) {
      // Add radii properties to point
      this.addRadiiToPoint(hoverPoint);

      // Update mitered points
      sqftShapeManager.updateMinMaxMiteredPoints(hoverShape);
      // Reset seam shape changes in the slab mode
      sqftShapeManager.resetShapeChangesInTheSlabMode(hoverShape);
      // Update hoverMiteredPoint position
      let hoverMiteredPoint = workspace.getHoverMiteredPoint();
      if (hoverMiteredPoint) {
        hoverMiteredPoint.getParent().movePoint(0, 0, hoverMiteredPoint);
        hoverMiteredPoint.getParent().moveMeasurements(hoverMiteredPoint);
        // todo sqft-react
        // Menu.miteredController.updateInfo();
      }
      return false;
    } else if (hoverShape) {
      // Menu.openMenu();
      // return true;  // if click on shape, block reseting cursor, because we still need it http://jira.mozidev.com/browse/QC-956
    }/* else {
      deregisterEvents();
      elements.designDefault.click();
    }*/
  };

  this.destroy = function(protect, revertBackAfterMouseUp) {
    if (revertBackAfterMouseUp) {
      eventManager.removeEvent(self, eventManager.events.RENDER); //remove render only, but wait for mouse up to set cursor again
      this.isWaitingToRestoreCursor = true;
    } else {
      this.deregisterEvents();
    }
    this.hide();
  };
  this.hide = function(e) {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    //Menu.hideSideBarContent(); // hide sidebar menu
  };

  //public functions
  this.init = function() {
    // elements.navRadius.click(navRadius_onClick);
    createRadiusElements();
    createCornerElements();

    elements.arcButtons.click(self.arcButton_onClick);
    elements.angleButtons.click(self.angleButton_onClick);
  };

  this.renderCursor = function(ctx) {
    // if((this.arcLength > 0) && ($(window).width() > 768)) {
    //   var mPos = eventManager.LastKnownMousePos;
    //   if(mPos) {
    //     ctx.save();
    //     ctx.font = "18px " + config.activeFontBold;
    //     ctx.fillStyle = "#B263A8";
    //     ctx.fillText("r" + new Fraction(this.arcLength) + "\"", mPos.x + (12 * config.scale), mPos.y + 9);
    //     ctx.restore();
    //   }
    // }
    if(self.cursorImage && self.cursorImage.image && (this.arcLength > 0 || this.angle > 0) && ($(window).width() > 768)) {
      var mPos = eventManager.LastKnownMousePos;
      if(mPos) {
        ctx.drawImage(self.cursorImage.image, mPos.x + 10, mPos.y + 10, self.cursorImage.width, self.cursorImage.height);
      }
    }
  };
};
